import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import routes from '../routing/routes';
import GlobalErrors from '../module/GlobalErrors';
import PageHeadingWithBackButton from '../module/PageHeadingWithBackButton';
import useDetailTerminu from '../module/DetailTerminu/hook/useDetailTerminu';
import DetailTerminu from '../module/DetailTerminu/DetailTerminu';
import Layout from './Layout';
import SecuredPage from '../module/SecuredPage';

const DetailTerminuPage = (): ReactElement => {
  const { uuid } = useParams<{ uuid: string }>();
  const {
    termin,
    terminStatus,
    reloadTermin,
  } = useDetailTerminu(uuid);

  useEffect(() => {
    if (!terminStatus?.loading) {
      setTitle(getTitle());
    }
  }, [terminStatus.loading]);

  return (
    <Layout>
      <>
        <Breadcrumbs routeList={[
          homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
          {
            to: routes.tezaurus.list,
            heading: 'Tezaurus slovenského práva',
          },
          {
            to: routes.tezaurus.detail.withParams(uuid),
            heading: termin?.preferovanyTermin || 'Detail termínu',
          },
        ]}
        />
        <GlobalErrors />
        <SecuredPage requestStatus={terminStatus.responseCode}>
          <Loader loading={terminStatus?.loading}>
            {termin && (
              <>
                <PageHeadingWithBackButton
                  heading={termin.preferovanyTermin}
                  backLinkText="Späť"
                  headingCaption="Termín"
                  withBackLink
                />
                <DetailTerminu termin={termin} reloadTermin={reloadTermin} />
              </>
            )}
          </Loader>
        </SecuredPage>
      </>
    </Layout>
  );
};
export default DetailTerminuPage;
